<button mat-icon-button class="close-button" (click)="cerrar()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>

<h1 mat-dialog-title>
  <mat-icon class="icono-titulo">share</mat-icon>
  Compartir comprobante
</h1>

<div mat-dialog-content class="contenido-compartir">

  <ngx-spinner [zIndex]="100" name="spCompartir" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
    type="ball-atom" [fullScreen]="false"></ngx-spinner>

  <p class="detalle-comprobante">
    <strong>Nro. {{ data.nroComprobante }}</strong>
    <span *ngIf="data.descripcion"> — {{ data.descripcion }}</span>
  </p>

  <p class="aviso-reconstruido" *ngIf="pdf && pdf.reconstruido">
    <mat-icon>restore_page</mat-icon>
    El archivo original ya no está: el PDF se reconstruyó desde el respaldo.
  </p>

  <p class="aviso-error" *ngIf="error">
    <mat-icon>error_outline</mat-icon>
    {{ error }}
  </p>

  <div class="acciones-compartir" *ngIf="pdf && !error">

    <!-- Camino bueno: bandeja del sistema, con el PDF adjunto de verdad -->
    <button mat-raised-button color="primary" class="accion-principal" *ngIf="soportaCompartirNativo"
      (click)="compartirNativo()">
      <mat-icon>share</mat-icon>
      Compartir…
    </button>

    <p class="nota-soporte" *ngIf="!soportaCompartirNativo">
      Este navegador no permite compartir archivos directamente. Con las opciones
      de abajo el PDF se descarga y después lo adjuntás.
    </p>

    <div class="grilla-acciones">

      <button mat-stroked-button (click)="compartirWhatsApp()"
        matTooltip="Descarga el PDF y abre WhatsApp con el mensaje escrito. El archivo se adjunta a mano.">
        <mat-icon>chat</mat-icon>
        WhatsApp
      </button>

      <button mat-stroked-button (click)="compartirCorreo()"
        matTooltip="Descarga el PDF y abre tu cliente de correo con el asunto y el cuerpo listos.">
        <mat-icon>mail_outline</mat-icon>
        Correo
      </button>

      <button mat-stroked-button (click)="abrirEnPestania()" matTooltip="Ver el PDF antes de mandarlo">
        <mat-icon>open_in_new</mat-icon>
        Abrir
      </button>

      <button mat-stroked-button (click)="descargar()">
        <mat-icon>file_download</mat-icon>
        Descargar
      </button>

      <button mat-stroked-button (click)="copiarTexto()" matTooltip="Copia el texto de referencia del comprobante">
        <mat-icon>content_copy</mat-icon>
        Copiar texto
      </button>

    </div>
  </div>

</div>

<mat-divider></mat-divider>

<div mat-dialog-actions>
  <button mat-button color="warn" (click)="cerrar()">Cerrar</button>
</div>
